export const REGEX = {
  email: /^[a-zA-Z0-9.\-_a-zA-Z0-9]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
  phoneNumber:
    /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
  password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*\d).{8,}$/,
  number: /^\d{9,}$/,
  formatNumber: /^-?\d+(\.\d+)?$/,
};
export const PASSWORD_PATTERN =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*\d).{8,}$/;
export const UPPER_CASE_TEXT = /[A-Z]/;
export const LOWER_TEXT = /[a-z]/;
export const NUMBER = /[0-9]/;
export const SPEACIAL_CHARACTER = /[!@#$%^&*]/;
export const LENGTH_CHARACTER = /^.{8,}/;
export const TEMPORARY_CHARACTER = 8;
export const PASSWORD_VALIDATOR =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*^[\S]+$)(?=.*[!@#$%^&*]).{8,}$/;

export enum VERYFY_PASSWORD {
  IS_UPPER_CASE = 'isUpperCase',
  IS_LOWER_CASE = 'isLowerCase',
  IS_CONTAIN_SPECIAL_CHARACTER = 'isContainSpecialCharacter',
  IS_CONTAIN_NUMBER = 'isContainNumber',
  IS_ENOUGH_LENGTH = 'isEnoughLength',
}

export const VALIDATE_VIETNAMESE_FROM =
  'àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ';

export const VALIDATE_VIETNAMESE_TO =
  'aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy';
